// extracted by css-extract-rspack-plugin
export default {"error":"dCfIgYwqpCEJ2jWC","body":"BE58jsKFUecDgev7"};